<template>
  <AtomsGlobalDialog :is-open="dialog?.isOpen" :is-message-container="dialog?.isMessageContainer" @close="close" class="w-[800px]">

    <!-- heading -->

    <strong class="block mb-8 pr-8 pb-8 uppercase font-bold text-2xl border-b border-neutral-200 tablet:px-8">{{ $t('Dostupnost na prodejnách') }}</strong>

    <table class="dialog__availability-on-stores">
      <tbody>
        <tr>
          <th class="!text-left font-normal">{{ $t('Varianta') }}</th>
          <th v-for="supplier in appConfig.suppliers.filter(supplier => appConfig.supplierIdsToIncludeInAvailabilityDialog.includes(supplier.supplierId))">{{ supplier.name }}</th>
        </tr>
        <tr v-for="variant in dialog?.data.variants.sort((a, b) => a.name.localeCompare(b.name))">
          <td class="!text-left">{{ variant.name }}</td>
          <td v-for="supplierId in appConfig.supplierIdsToIncludeInAvailabilityDialog" :class="getClass(variant, supplierId)">{{ getLabel(variant, supplierId) }}</td>
        </tr>
      </tbody>
    </table>

    <div class="space-y-4 tracking-normal">
      <p v-html="i18n.t('<strong>E-shop</strong> = Máme minimálně 1 volný kus k okamžitému odeslání.')"></p>
      <p v-html="i18n.t('<strong>Skladem na prodejně</strong> = Máme minimálně 1 volný kus na dané prodejně. Chcete-li mít jistotu, že tam bude i v době, až tam dorazíte, raději si jej <strong>zarezervujte</strong> (objednáním s osobním odběrem v dané prodejně).')"></p>
      <p v-html="i18n.t('Pokud je <strong>zboží skladem na e-shopu, ale není na Vámi požadované prodejně</strong>, nevadí. Můžete si jej objednat stejným způsobem a my jej tam dopravíme. V tomto případě to nějaký čas bude trvat a je <strong>nutné opravdu vyčkat, až Vám doručení zboží na prodejnu potvrdíme</strong>.')"></p>
      <p v-html="i18n.t('Podobným způsob to funguje i <strong>opačným směrem</strong>. Zboží, které není skladem na e-shopu a je skladem na nějaké prodejně, si můžete objednat s doručením k Vám domů. <strong>Opět je ale nutné počítat s delší dobou doručení</strong>.')"></p>
    </div>
  </AtomsGlobalDialog>
</template>
<script setup>

const i18n = useI18n();
const appConfig = useAppConfig();

const dialog = computed(() => useDialog().get('availabilityOnStores'));

const isStored = (variant, supplierId) => variant.stores.find(store => store.idSupplier === supplierId)?.stored;


const getClass = (variant, supplierId) => {

  if (variant.onWay && appConfig.suppliers.find(supplier => supplier.isDefault && supplier.supplierId === supplierId)) {
    return 'uppercase text-warning-500';
  }

  if (isStored(variant, supplierId)) {
    return 'uppercase text-success-600';
  } else {
    return 'uppercase text-error-500';
  }
}

const getLabel = (variant, supplierId) => {

  if (variant.onWay && appConfig.suppliers.find(supplier => supplier.isDefault && supplier.supplierId === supplierId)) {
    return i18n.t('Na cestě');
  }

  if (isStored(variant, supplierId)) {
    return i18n.t('Skladem');
  } else {
    return i18n.t('Není skladem');
  }
}

const close = () => useDialog().close();

</script>
<style lang="postcss">
.dialog__availability-on-stores {
  @apply w-full mb-8;
  border-collapse: collapse;

  th {
    @apply px-2 py-6 text-sm uppercase text-center text-neutral-50 bg-neutral-500 tablet:px-4;
  }

  td {
    @apply px-2 py-2 text-sm border-b border-neutral-200 text-center tablet:px-4 tablet:py-3;
  }
}
</style>